var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDraftDraft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 20.4599L19.7 12.2599C20.2 11.7599 20.8 11.4599 21.5 11.4599C22.2 11.4599 22.8 11.7599 23.3 12.2599L23.5 12.4599V4.35986C23.5 3.25986 22.6 2.35986 21.5 2.35986H3.5C2.4 2.35986 1.5 3.25986 1.5 4.35986V20.3599C1.5 21.4599 2.4 22.3599 3.5 22.3599H11.5V20.4599ZM3.5 4.35986H21.5V7.35986H3.5V4.35986ZM21.5 13.4599C21.4 13.4599 21.2 13.5599 21.1 13.6599L20.1 14.6599L22.2 16.7599L23.2 15.7599C23.4 15.5599 23.4 15.1599 23.2 14.9599L21.9 13.6599C21.8 13.5599 21.7 13.4599 21.5 13.4599ZM19.6 15.2599L13.5 21.2599V23.3599H15.6L21.7 17.2599L19.6 15.2599Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDraftDraft);
export default __webpack_public_path__ + "static/media/DraftDraft.27e8899fd6b299a5184af9c347da68cc.svg";
export { ForwardRef as ReactComponent };